import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/layout/PageShell";
import { db } from "../config/firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";

export default function Announcements() {
  const [firebaseAnnouncements, setFirebaseAnnouncements] = useState([]);
  const [loadingFirebase, setLoadingFirebase] = useState(true);

  /* =========================================================
     CHARGEMENT FIREBASE
  ========================================================= */
  useEffect(() => {
    async function fetchAnnouncements() {
      try {
        const q = query(
          collection(db, "announcements"),
          orderBy("published_at", "desc")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map((firebaseDoc) => ({
          id: firebaseDoc.id,
          source: "firebase",
          ...firebaseDoc.data(),
        }));

        setFirebaseAnnouncements(data);
      } catch (error) {
        console.error("Erreur chargement Firebase :", error);
      } finally {
        setLoadingFirebase(false);
      }
    }

    fetchAnnouncements();
  }, []);

  /* =========================================================
     ANCIENNES ACTUALITÉS LOCALES
  ========================================================= */
  const localAnnouncements = useMemo(
    () => [
      {
        id: "local-11",
        title:
          "Présentation de la Commission technique de coordination pour la réforme pénale",
        summary:
          "Installation de la commission technique chargée de l'élaboration du programme de formation pour la mise en œuvre de la réforme pénale.",
        content:
          "Présentation de la commission technique de coordination et d'élaboration du programme de formation pour la mise en œuvre de la réforme pénale.",
        type: "info",
        priority: "urgent",
        published_at: "2026-07-20",
        views_count: 45,
        category: "Institutionnel",
        image: "/media/photos/comm_tech.jpeg",
        source: "local",
      },
      {
        id: "local-10",
        title: "8e promotion : 49 élèves magistrats prêteront serment",
        summary:
          "Le CSPJ annonce la cérémonie de prestation de serment de la 8e promotion le 26 juin 2026.",
        content:
          "Cérémonie de prestation de serment de la 8e promotion de l'EMA.",
        type: "communique",
        priority: "urgent",
        published_at: "2026-06-23",
        views_count: 250,
        category: "Communiqué officiel",
        image: "/media/photos/cer1.jpeg",
        link: "/actualites/prestation-serment-8e-promotion",
        source: "local",
        emitter: "Conseil Supérieur du Pouvoir Judiciaire",
        logo: "/partenaires/cspj-logo.jpg",
        gallery: [
          "/media/photos/cer1.jpeg",
          "/media/photos/cer2.jpeg",
          "/media/photos/cer3.jpeg",
          "/media/photos/cer4.jpeg",
        ],
      },
      {
        id: "local-8",
        title:
          "Match des élèves Magistrats en l’honneur des Grenadiers",
        summary:
          "Les élèves magistrats de l’EMA ont organisé un match de football en l’honneur des Grenadiers.",
        content:
          "Dans le cadre des activités de cohésion et de vie de l’École, les élèves magistrats ont disputé un match de football en l’honneur des Grenadiers d’Haïti.",
        type: "info",
        priority: "high",
        published_at: "2026-06-23",
        views_count: 100,
        category: "Vie de l’École",
        image: "/media/photos/match-ema.jpeg",
        source: "local",
      },
      {
        id: "local-9",
        title: "Note de départ en stage pour les élèves magistrats",
        summary:
          "Communiqué officiel relatif au départ en stage des élèves magistrats de l’EMA.",
        content:
          "La Direction de l’École de la Magistrature informe les élèves magistrats des dispositions relatives à leur départ en stage.",
        type: "info",
        priority: "urgent",
        published_at: "2026-06-26",
        views_count: 90,
        category: "Communiqué",
        image: "/media/photos/promotion8_3.jpg",
        document: "/documents/info_ema.pdf",
        source: "local",
      },
      {
        id: "local-7",
        title: "Reprise des cours – Second trimestre",
        summary:
          "La Direction des Études souhaite un bon retour aux élèves-magistrats et leur souhaite plein succès dans leurs activités de formation pour ce second trimestre.",
        content:
          "La Direction des Études souhaite un bon retour aux élèves-magistrats et leur souhaite plein succès dans leurs activités de formation pour ce second trimestre.",
        type: "info",
        priority: "urgent",
        published_at: "2026-04-13",
        views_count: 52,
        category: "Formation",
        image: "/media/photos/promotion8_2.jpg",
        source: "local",
      },
      {
        id: "local-6",
        title: "Note d'information – Fin du premier trimestre et congés",
        summary:
          "La Direction des Études informe les formateurs que les élèves magistrats ont achevé leur premier trimestre.",
        content:
          "La Direction des Études informe les formateurs que les élèves magistrats ont achevé leur premier trimestre. Ils partiront en vacances à compter du 28 mars 2026 et reprendront les cours le lundi 13 avril 2026.\n\nLes formateurs programmés pour le second trimestre sont invités à prendre toutes les dispositions nécessaires en vue d'assurer la dispensation de leurs enseignements dans les conditions préalablement établies.\n\nLa Direction des Études compte sur la collaboration de chacun pour la bonne poursuite des activités académiques.",
        type: "info",
        priority: "high",
        published_at: "2026-03-27",
        views_count: 100,
        category: "Information",
        image: "/media/photos/proces1.jpeg",
        source: "local",
      },
      {
        id: "local-5",
        title: "Formation probatoire des juges de paix : examens écrits",
        summary:
          "Les candidats concernés sont attendus le jeudi 19 mars 2026 pour passer les examens écrits dans les centres de Grand Sud et Grand Nord.",
        content:
          "Les candidats concernés sont attendus le jeudi 19 mars 2026 à compter de 8 heures AM pour passer les examens écrits. Les centres retenus sont les suivants : Grand Sud — Bergeaud, au local du Lycée Claudy Musseau ; Grand Nord — Auditorium du Bâtonnat du Cap-Haïtien, rue 22A. Matières annoncées : droit civil / procédure civile et droit pénal / procédure pénale.",
        type: "exam",
        priority: "urgent",
        published_at: "2026-03-12",
        views_count: 511,
        category: "Concours",
        image: "/media/photos/proces2.jpeg",
        source: "local",
      },
      {
        id: "local-1",
        title: "Ouverture des activités de formation",
        summary:
          "L'École de la Magistrature informe le public et les candidats que les activités pédagogiques et institutionnelles se poursuivent.",
        content:
          "L'École de la Magistrature informe le public et les candidats que les activités pédagogiques et institutionnelles se poursuivent conformément au calendrier académique en vigueur.",
        type: "info",
        priority: "normal",
        published_at: "2026-03-01",
        views_count: 18,
        category: "Formation",
        image: "/media/photos/promotion8_2.jpg",
        source: "local",
      },
      {
        id: "local-2",
        title: "Calendrier de la 8e promotion disponible",
        summary:
          "Le calendrier officiel de la 8e promotion (2025–2027) est disponible dans la section Formations.",
        content:
          "Le calendrier officiel de la 8e promotion (2025–2027) est disponible dans la section Formations. Les candidats et apprenants sont invités à le consulter régulièrement.",
        type: "exam",
        priority: "high",
        published_at: "2026-02-26",
        views_count: 32,
        category: "Promotion",
        image: "/media/photos/promotion8_3.jpg",
        source: "local",
      },
      {
        id: "local-3",
        title: "Publication des avis officiels",
        summary:
          "Les communiqués relatifs aux concours, aux sessions de formation et aux informations administratives seront publiés progressivement.",
        content:
          "Les communiqués relatifs aux concours, aux sessions de formation et aux informations administratives seront publiés progressivement sur cette page officielle.",
        type: "result",
        priority: "normal",
        published_at: "2026-02-20",
        views_count: 21,
        category: "Information",
        image: "/media/photos/promotion8_4.jpg",
        source: "local",
      },
      {
        id: "local-4",
        title: "Vérification régulière recommandée",
        summary:
          "Les usagers sont invités à consulter régulièrement cette rubrique afin de se tenir informés des annonces.",
        content:
          "Les usagers sont invités à consulter régulièrement cette rubrique afin de se tenir informés des annonces, convocations, résultats et autres communications officielles.",
        type: "urgent",
        priority: "urgent",
        published_at: "2026-02-15",
        views_count: 41,
        category: "Information",
        image: "/media/photos/promotion8_5.jpg",
        source: "local",
      },
    ],
    []
  );

  /* =========================================================
     OUTILS
  ========================================================= */
  const getTypeLabel = (type) => {
    switch (type) {
      case "exam":
        return "Examen";
      case "result":
        return "Résultat";
      case "urgent":
        return "Urgent";
      case "communique":
        return "Communiqué";
      default:
        return "Information";
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "exam":
        return "#0B2C5F";
      case "result":
        return "#059669";
      case "urgent":
        return "#DC2626";
      case "communique":
        return "#0B2C5F";
      default:
        return "#3B82F6";
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "urgent":
        return "Urgent";
      case "high":
        return "Important";
      default:
        return null;
    }
  };

  const formatDateFR = (value) => {
    const d = new Date(value);

    if (Number.isNaN(d.getTime())) return "—";

    return d.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  /* =========================================================
     FUSION DES ACTUALITÉS
  ========================================================= */
  const allAnnouncements = useMemo(() => {
    return [...firebaseAnnouncements, ...localAnnouncements];
  }, [firebaseAnnouncements, localAnnouncements]);

  /* =========================================================
     TRI PAR DATE
     La plus récente apparaît en premier
  ========================================================= */
  const sortedAnnouncements = useMemo(() => {
    return [...allAnnouncements].sort((a, b) => {
      const dateB = new Date(b.published_at || 0).getTime();
      const dateA = new Date(a.published_at || 0).getTime();

      return dateB - dateA;
    });
  }, [allAnnouncements]);

  /* =========================================================
     ACTUALITÉ À LA UNE
  ========================================================= */
  const featuredAnnouncement = useMemo(() => {
    if (sortedAnnouncements.length === 0) {
      return null;
    }

    return sortedAnnouncements[0];
  }, [sortedAnnouncements]);

  /* =========================================================
     AUTRES ACTUALITÉS
  ========================================================= */
  const otherAnnouncements = useMemo(() => {
    if (!featuredAnnouncement) {
      return [];
    }

    return sortedAnnouncements.filter(
      (announcement) => announcement.id !== featuredAnnouncement.id
    );
  }, [sortedAnnouncements, featuredAnnouncement]);

  /* =========================================================
     CHARGEMENT
  ========================================================= */
  if (loadingFirebase && localAnnouncements.length === 0) {
    return (
      <PageShell
        title="Actualités"
        subtitle="Annonces et communiqués officiels de l'École de la Magistrature"
      >
        <section className="ema-block">
          <div
            style={{
              textAlign: "center",
              padding: "60px 20px",
              color: "#6B7280",
            }}
          >
            Chargement des actualités...
          </div>
        </section>
      </PageShell>
    );
  }

  /* =========================================================
     AUCUNE ACTUALITÉ
  ========================================================= */
  if (!featuredAnnouncement) {
    return (
      <PageShell
        title="Actualités"
        subtitle="Annonces et communiqués officiels de l'École de la Magistrature"
      >
        <section className="ema-block">
          <p className="ema-paragraph">
            Aucune actualité disponible pour le moment.
          </p>
        </section>
      </PageShell>
    );
  }

  /* =========================================================
     AFFICHAGE
  ========================================================= */
  return (
    <PageShell
      title="Actualités"
      subtitle="Annonces et communiqués officiels de l'École de la Magistrature"
    >
      {/* =====================================================
          ACTUALITÉ PRINCIPALE
      ====================================================== */}
      <section className="ema-block">
        <div
          className="ema-card ema-card-hover"
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "20px",
            padding: 0,
            boxShadow: "0 4px 20px rgba(11,44,95,0.1)",
            overflow: "hidden",
            transition: "all 0.3s ease",
          }}
        >
          {/* Image principale */}
          <div
            style={{
              height: "340px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <img
              src={
                featuredAnnouncement.image ||
                featuredAnnouncement.gallery?.[0] ||
                "/media/photos/promotion8_4.jpg"
              }
              alt={featuredAnnouncement.title}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, transparent 45%, rgba(0,0,0,0.55) 100%)",
              }}
            />
          </div>

          <div style={{ padding: "32px" }}>
            {/* Organisme émetteur */}
            {featuredAnnouncement.emitter && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "16px",
                }}
              >
                {featuredAnnouncement.logo && (
                  <img
                    src={featuredAnnouncement.logo}
                    alt=""
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      padding: "3px",
                    }}
                  />
                )}

                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6B7280",
                  }}
                >
                  {featuredAnnouncement.emitter}
                </span>
              </div>
            )}

            {/* Badges */}
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                marginBottom: "16px",
              }}
            >
              <span
                style={{
                  background: "#DC2626",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.4px",
                  textTransform: "uppercase",
                }}
              >
                {featuredAnnouncement.category || "Actualité"}
              </span>

              <span
                style={{
                  background: "#0B2C5F",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                À la une
              </span>

              {getPriorityLabel(featuredAnnouncement.priority) && (
                <span
                  style={{
                    background:
                      featuredAnnouncement.priority === "urgent"
                        ? "#DC2626"
                        : "#F59E0B",
                    color: "#fff",
                    padding: "6px 14px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {getPriorityLabel(featuredAnnouncement.priority)}
                </span>
              )}
            </div>

            {/* Titre */}
            <h2
              className="ema-h3"
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#0B2C5F",
                marginBottom: "14px",
                lineHeight: 1.3,
              }}
            >
              {featuredAnnouncement.title}
            </h2>

            {/* Résumé */}
            {featuredAnnouncement.summary && (
              <p
                className="ema-lead"
                style={{
                  color: "#6B7280",
                  marginBottom: "20px",
                  lineHeight: 1.7,
                }}
              >
                {featuredAnnouncement.summary}
              </p>
            )}

            {/* Contenu */}
            {featuredAnnouncement.content && (
              <p
                className="ema-paragraph"
                style={{
                  color: "#374151",
                  marginBottom: "24px",
                  lineHeight: 1.8,
                  whiteSpace: "pre-line",
                }}
              >
                {featuredAnnouncement.content}
              </p>
            )}

            {/* Galerie */}
            {featuredAnnouncement.gallery &&
              featuredAnnouncement.gallery.length > 0 && (
                <div style={{ marginBottom: "24px" }}>
                  <h4
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#0B2C5F",
                      marginBottom: "12px",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    Photos
                  </h4>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(150px, 1fr))",
                      gap: "10px",
                    }}
                  >
                    {featuredAnnouncement.gallery.map((src, idx) => (
                      <div
                        key={idx}
                        style={{
                          borderRadius: "10px",
                          overflow: "hidden",
                          aspectRatio: "1",
                        }}
                      >
                        <img
                          src={src}
                          alt={`${featuredAnnouncement.title} ${idx + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform 0.4s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.05)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* Bouton lien */}
            {featuredAnnouncement.link && (
              <div style={{ marginBottom: "20px" }}>
                <Link
                  to={featuredAnnouncement.link}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "14px 28px",
                    background: "#0B2C5F",
                    borderRadius: "12px",
                    textDecoration: "none",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  Lire la publication complète →
                </Link>
              </div>
            )}

            {/* PDF */}
            {featuredAnnouncement.document && (
              <div style={{ marginBottom: "20px" }}>
                <a
                  href={featuredAnnouncement.document}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "12px 20px",
                    color: "#0B2C5F",
                    background: "rgba(11,44,95,0.05)",
                    border: "1px solid rgba(11,44,95,0.2)",
                    borderRadius: "10px",
                    textDecoration: "none",
                    fontWeight: 600,
                  }}
                >
                  Télécharger le document PDF
                </a>
              </div>
            )}

            {/* Métadonnées */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "8px",
                paddingTop: "16px",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  color: "#6B7280",
                }}
              >
                Publié le{" "}
                {formatDateFR(featuredAnnouncement.published_at)}
              </span>

              {Number(featuredAnnouncement.views_count) > 0 && (
                <span
                  style={{
                    fontSize: "14px",
                    color: "#6B7280",
                  }}
                >
                  {featuredAnnouncement.views_count} vue
                  {featuredAnnouncement.views_count > 1 ? "s" : ""}
                </span>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* =====================================================
          AUTRES ACTUALITÉS
      ====================================================== */}
      <section className="ema-block">
        <h2 className="ema-h3">Toutes les actualités</h2>

        <div
          style={{
            marginTop: 24,
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "24px",
          }}
        >
          {otherAnnouncements.map((announcement) => (
            <Link
              key={announcement.id}
              to={announcement.link || "/announcements"}
              className="ema-card ema-card-hover"
              style={{
                textDecoration: "none",
                background: "#fff",
                border:
                  announcement.priority === "urgent"
                    ? "2px solid #DC2626"
                    : "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: 0,
                boxShadow: "0 2px 12px rgba(11,44,95,0.08)",
                transition: "all 0.3s ease",
                overflow: "hidden",
                cursor: "pointer",
                display: "block",
              }}
            >
              {/* Image */}
              <div
                style={{
                  height: "180px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <img
                  src={
                    announcement.image ||
                    announcement.gallery?.[0] ||
                    "/media/photos/promotion8_4.jpg"
                  }
                  alt={announcement.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.4s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </div>

              <div style={{ padding: "24px" }}>
                {/* Badges */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      background: getTypeColor(announcement.type),
                      color: "#fff",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: "11px",
                      fontWeight: 600,
                    }}
                  >
                    {getTypeLabel(announcement.type)}
                  </span>

                  {announcement.category && (
                    <span
                      style={{
                        background: "rgba(11,44,95,0.08)",
                        color: "#0B2C5F",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {announcement.category}
                    </span>
                  )}

                  {getPriorityLabel(announcement.priority) && (
                    <span
                      style={{
                        background:
                          announcement.priority === "urgent"
                            ? "#DC2626"
                            : "#F59E0B",
                        color: "#fff",
                        padding: "4px 12px",
                        borderRadius: "20px",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {getPriorityLabel(announcement.priority)}
                    </span>
                  )}
                </div>

                {/* Titre */}
                <h3
                  className="ema-h3"
                  style={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#0B2C5F",
                    marginBottom: "8px",
                    lineHeight: 1.3,
                  }}
                >
                  {announcement.title}
                </h3>

                {/* Résumé */}
                <p
                  className="ema-paragraph"
                  style={{
                    color: "#6B7280",
                    marginBottom: "16px",
                    lineHeight: 1.6,
                    fontSize: "14px",
                  }}
                >
                  {announcement.summary}
                </p>

                {/* Actions */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      display: "inline-flex",
                      padding: "8px 16px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#0B2C5F",
                      border: "1px solid #0B2C5F",
                      borderRadius: "8px",
                    }}
                  >
                    Lire la suite →
                  </span>

                  {announcement.document && (
                    <a
                      href={announcement.document}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "8px 16px",
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#0B2C5F",
                        background: "rgba(11,44,95,0.05)",
                        border: "1px solid rgba(11,44,95,0.15)",
                        borderRadius: "8px",
                        textDecoration: "none",
                      }}
                    >
                      PDF
                    </a>
                  )}
                </div>

                {/* Date / vues */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginTop: "16px",
                    paddingTop: "16px",
                    borderTop: "1px solid #e5e7eb",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6B7280",
                    }}
                  >
                    {formatDateFR(announcement.published_at)}
                  </span>

                  {Number(announcement.views_count) > 0 && (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#6B7280",
                      }}
                    >
                      {announcement.views_count} vue
                      {announcement.views_count > 1 ? "s" : ""}
                    </span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </PageShell>
  );
}